/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';
import { sdCreateRequest, sdMakeRequests, sdRenderLoadingOrError, sdRequestsCompleted, sdShowToast, sdUTCTimestampStrToLocalStr, sdTimeAgoFromUTCTimestamp } from 'helpers/sdHelper';
import { sdGetProject, sdGetProjectMailboxLoginUrl, sdUpdateProject } from 'services/service-desk/sdService';
import SDPageHeader from '../../SDPageHeader';
import { Button, Card, Form, Table } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

const SDProject = () => {
    const { projectId } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [project, setProject] = useState(null);
    const [projectMailboxEnabledCheck, setProjectMailboxEnabledCheck] = useState(false);

    useEffect(() => {
        let allRequests = [
            sdCreateRequest(() => sdGetProject(projectId), setProject),
        ];

        sdMakeRequests(allRequests, setLoading, setError);
    }, []);

    useEffect(() => {
        if (project) {
            setProjectMailboxEnabledCheck(project.mailboxEnabled);
        }
    }, [project])

    const reloadProject = (e) => {
        sdGetProject(projectId).then(res => {
            setProject(res.data);
        }).catch(err => {
            console.error(err);
        })
    }
    const handleProjectMailboxCheckChanged = (e) => {
        let checked = e.target.checked;

        sdUpdateProject(projectId, {
            mailboxEnabled: checked
        }).then(res => {
            console.log(res.data);
            sdShowToast("Project Updated", false);
        }).catch(err => {
            console.error(err);
            sdShowToast("Failed to update project", true);
        }).finally(() => {
            reloadProject();
        })
    }

    const mailboxSignIn = () => {
        sdGetProjectMailboxLoginUrl(projectId).then(res => {
            let url = res.data;
            console.log("URL", url);
            const win = window.open(url, "_blank");

            // Reload the current page after the window has been closed!!
            const checkWindowClosed = setInterval(() => {
                if (win.closed) {
                    clearInterval(checkWindowClosed);
                    reloadProject();
                }
            }, 500);

        }).catch(err => {
            console.log(err);
        })
    };

    if (!sdRequestsCompleted(loading, error)) {
        return sdRenderLoadingOrError(loading, error);
    }

    return (<>
        <SDPageHeader title={"Edit Project - " + project.name}></SDPageHeader>

        {/* Basic project details */}
        <Card className='mb-3'>
            <Card.Body>
                {/* Name */}
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" value={project.name} disabled />
                </Form.Group>

                {/* Key */}
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Key</Form.Label>
                    <Form.Control type="text" value={project.key} disabled />
                </Form.Group>
            </Card.Body>
        </Card>

        {/* Mailbox */}
        <Card className='mb-3'>
            <Card.Body className='p-2'>
                <Card.Title as="div">Mailbox</Card.Title>

                <Form.Check
                    type='switch'
                    id='defaultSwitch'
                    label='Enabled'
                    checked={projectMailboxEnabledCheck}
                    onChange={handleProjectMailboxCheckChanged}
                />

                {/* Mailbox Name */}
                {project.mailboxName ? <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Mailbox Name</Form.Label>
                    <Form.Control type="text" value={project.mailboxName} disabled />
                </Form.Group> : <></>
                }

                {/* Mailbox Last Process */}
                {project.mailboxLastProcess ? <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Mailbox Last Process TIme</Form.Label>
                    <Form.Control type="text" value={`${sdUTCTimestampStrToLocalStr(project.mailboxLastProcess)} (${sdTimeAgoFromUTCTimestamp(project.mailboxLastProcess)})`} disabled />
                </Form.Group> : <></>
                }

                <Button variant='primary' className='me-2 mb-1' onClick={mailboxSignIn}>Sign In With Microsoft</Button>
            </Card.Body>
        </Card>

        {/* Categories */}
        <Card className='mb-3'>
            <Card.Body className='p-2'>
                <Card.Title as="div">Categories</Card.Title>
                <ProjectCategoryTable project={project}></ProjectCategoryTable>
            </Card.Body>
        </Card>

        {/* Statuses */}
        <Card className='mb-3'>
            <Card.Body className='p-2'>
                <Card.Title as="div">Statuses</Card.Title>
                <ProjectStatusTable project={project}></ProjectStatusTable>
            </Card.Body>
        </Card>

        {/* Priorities */}
        <Card className='mb-3'>
            <Card.Body className='p-2'>
                <Card.Title as="div">Priorities</Card.Title>
                <ProjectPriorityTable project={project}></ProjectPriorityTable>
            </Card.Body>
        </Card>

        {/* Users */}
        <Card className='mb-3'>
            <Card.Body className='p-2'>
                <Card.Title as="div">Users</Card.Title>
                <ProjectUsersTable project={project}></ProjectUsersTable>
            </Card.Body>
        </Card>

    </>)
}

const ProjectCategoryTable = ({ project }) => {

    return (<Table bordered striped responsive hover size='sm'>
        <thead>
            <tr>
            </tr>
        </thead>
        <tbody>
            {project.categories.map((cat) => {
                return (
                    <tr key={cat.id}>
                        <td>{cat.name}</td>
                    </tr>
                );
            })}
        </tbody>
    </Table>);
}

const ProjectStatusTable = ({ project }) => {

    return (<Table bordered striped responsive hover size='sm'>
        <thead>
            <tr>
            </tr>
        </thead>
        <tbody>
            {project.statuses.map((cat) => {
                return (
                    <tr key={cat.id}>
                        <td>{cat.name}</td>
                    </tr>
                );
            })}
        </tbody>
    </Table>);
}

const ProjectPriorityTable = ({ project }) => {

    return (<Table bordered striped responsive hover size='sm'>
        <thead>
            <tr>
            </tr>
        </thead>
        <tbody>
            {project.priorities.map((cat) => {
                return (
                    <tr key={cat.id}>
                        <td>{cat.name}</td>
                    </tr>
                );
            })}
        </tbody>
    </Table>);
}

const ProjectUsersTable = ({ project }) => {
    console.log("USERS ->", project.users)
    return (<Table bordered striped responsive hover size='sm'>
        <thead>
            <tr>
                <th scope="col">ID</th>
                <th scope="col">Email</th>
                <th scope="col">Display Name</th>
                <th scope="col">Role</th>
            </tr>
        </thead>
        <tbody>
            {project.users.map((item) => {
                return (
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.email}</td>
                        <td>{item.displayName}</td>
                        <td>{item.role}</td>
                    </tr>
                );
            })}
        </tbody>
    </Table>);
}

export default SDProject;